import { checkMatchInn, checkMatchNameBday, checkMatchNameEmail, checkMatchNamePhone, checkMatchSnils, checkName, checkNotEmpty, getBankValidationInfo, getOrganizationValidationInfo, validateBirthDay, validateComboBox, validateEmail, validateEmployeeINN, validateMirCardNumber, validatePhone, validateSnils, } from '@skbkontur/staff-common';
export const checkEmployeeLastName = ({ lastName, firstName, middleName, birthday, email, phone, matchFields: matchValue, matchValidationLevel: level, }) => {
    return (checkName({ value: lastName, required: true }) ||
        checkMatchNameBday({ value: { lastName, firstName, middleName, birthday }, matchValue, level }) ||
        checkMatchNameEmail({ value: { lastName, firstName, middleName, email }, matchValue, level }) ||
        checkMatchNamePhone({ value: { lastName, firstName, middleName, phone }, matchValue, level }));
};
export const checkEmployeeFirstName = ({ lastName, firstName, middleName, birthday, email, phone, matchFields: matchValue, matchValidationLevel: level, }) => {
    return (checkName({ value: firstName, required: true }) ||
        checkMatchNameBday({ value: { lastName, firstName, middleName, birthday }, matchValue, level }) ||
        checkMatchNameEmail({ value: { lastName, firstName, middleName, email }, matchValue, level }) ||
        checkMatchNamePhone({ value: { lastName, firstName, middleName, phone }, matchValue, level }));
};
export const checkEmployeeMiddleName = ({ lastName, firstName, middleName, birthday, email, phone, matchFields: matchValue, matchValidationLevel: level, }) => {
    return (checkName({ value: middleName, required: false }) ||
        checkMatchNameBday({ value: { lastName, firstName, middleName, birthday }, matchValue, level }) ||
        checkMatchNameEmail({ value: { lastName, firstName, middleName, email }, matchValue, level }) ||
        checkMatchNamePhone({ value: { lastName, firstName, middleName, phone }, matchValue, level }));
};
export const checkEmployeeBirthday = ({ lastName, firstName, middleName, birthday, matchFields: matchValue, matchValidationLevel: level, }) => {
    return (validateBirthDay({ value: birthday, required: true }) ||
        checkMatchNameBday({ value: { lastName, firstName, middleName, birthday }, matchValue, level }));
};
export const checkEmployeeSnils = ({ snils, matchFields: matchValue, matchValidationLevel: level }, fields) => {
    return (validateSnils({ value: snils || '', required: fields.snils?.required }) ||
        checkMatchSnils({ value: { snils }, matchValue, level }));
};
export const checkEmployeeInn = ({ inn, matchFields: matchValue, matchValidationLevel: level }, fields) => {
    return (validateEmployeeINN({ value: inn || '', required: fields.inn?.required }) ||
        checkMatchInn({ value: { inn }, matchValue, level }));
};
const checkAddress = (state, fields, addressType) => (fields[addressType]?.required ? checkNotEmpty({ value: state[addressType] }) : null);
export const checkEmployeeRegistrationAddress = (state, fields) => checkAddress(state, fields, 'registrationAddress');
export const checkEmployeeHomeAddress = (state, fields) => checkAddress(state, fields, 'homeAddress');
export const checkEmployeeResidentStatus = ({ residentStatus }, fields, references) => {
    return validateComboBox({
        value: residentStatus,
        items: references.residentStatuses,
        required: fields.residentStatus?.required,
    });
};
export const checkEmployeeCitizenship = ({ citizenship }, fields, references) => {
    return validateComboBox({
        value: citizenship,
        items: references.countries,
        required: fields.citizenship?.required,
    });
};
export const checkEmployeeEmail = ({ lastName, firstName, middleName, email, matchFields: matchValue, matchValidationLevel: level }, fields) => {
    return (validateEmail({ value: email || '', required: fields.email?.required }) ||
        checkMatchNameEmail({ value: { lastName, firstName, middleName, email }, matchValue, level }));
};
export const checkEmployeePhone = ({ lastName, firstName, middleName, phone, matchFields: matchValue, matchValidationLevel: level }, fields) => {
    return (validatePhone({ value: phone || '', required: fields.phone?.required }) ||
        checkMatchNamePhone({ value: { lastName, firstName, middleName, phone }, matchValue, level }));
};
export const getMainTabValidation = (state, fields, references) => {
    return [
        checkEmployeeLastName(state),
        checkEmployeeFirstName(state),
        checkEmployeeMiddleName(state),
        checkEmployeeBirthday(state),
        checkEmployeeSnils(state, fields),
        checkEmployeeInn(state, fields),
        checkEmployeeResidentStatus(state, fields, references),
        checkEmployeeCitizenship(state, fields, references),
        checkEmployeeRegistrationAddress(state, fields),
        checkEmployeeHomeAddress(state, fields),
        checkEmployeeEmail(state, fields),
        checkEmployeePhone(state, fields),
    ];
};
export const checkEmployeeBankAccount = ({ bankAccount }, fields) => {
    return (bankAccount &&
        getBankValidationInfo({
            requisites: bankAccount,
            required: fields.bankAccount?.required,
        }));
};
export const checkEmployeeMirCard = ({ mirCard }, fields) => {
    return validateMirCardNumber({
        value: mirCard || '',
        required: fields.mirCard?.required,
    });
};
export const checkEmployeeOrganization = ({ organization, showSfrField }, fields) => {
    return (organization &&
        getOrganizationValidationInfo({
            requisites: {
                ...organization,
                registrationNumberSfr: showSfrField ? organization.registrationNumberSfr || '' : undefined,
            },
            required: fields.organization?.required,
        }));
};
export const getPaymentTabValidation = (state, fields) => {
    return [
        ...Object.values(checkEmployeeBankAccount(state, fields) || {}),
        ...Object.values(checkEmployeeOrganization(state, fields) || {}),
        checkEmployeeMirCard(state, fields),
    ];
};
